// extracted by mini-css-extract-plugin
export default {"no-transactions":"no-transactions__16ire","text":"text__kyqf6"};